// eslint-disable-next-line import/no-anonymous-default-export
export default {
  MuiTextField: {
    styleOverrides: {
      root: {
        textTransform: "none",
      },
    },
    variants: [
      {
        props: { variant: "outlined", color: "primary" },
        style: ({ theme }) => ({
          // "& .MuiInputBase-root": {
          //   height: "45px",
          // },
          // "& .css-1wpg48b-MuiFormLabel-root-MuiInputLabel-root": {
          //   transform: "translate(14px, 12px) scale(1)",
          // },
          // "& .css-5ettvo-MuiFormHelperText-root": {
          //   fontSize: "12px",
          // },
        }),
      },
      {
        props: { variant: "solid", color: "primary" },
        style: ({ theme }) => ({
          height: "38px",
          color: theme.palette.white.main,
          background: theme.palette.primary[500],
          borderRadius: "3px",
          "&:hover": {
            background: theme.palette.primary[600],
          },
          "&:disabled ": {
            color: "#ffff",
            background: "#ddd",
          },
        }),
      },
      {
        props: { variant: "standard", color: "primary" },
        style: ({ theme }) => ({
          "& button": {
            transform: "translate(-11px, -5px)",
          },
        }),
      },
    ],
  },
};
